import React, { useRef, useState, useEffect } from "react";
import { Menu } from "@headlessui/react";

const PhoneCodeDropdown = ({
  textColor,
  title,
  onSelect,
  countryCodeDefualt,
}) => {
  const buttonRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(0);
  const [phoneCodes, setPhoneCodes] = useState([]);
  const [selectedItem, setSelectedItem] = useState({
    flag: null,
    name: "#00",
    country: "",
  });
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (buttonRef.current) {
      setButtonWidth(buttonRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    const fetchPhoneCodes = async () => {
      try {
        // https://restcountries.com/v3.1/all
        const response = await fetch("/countriesAPI.json");
        const data = await response.json();
        const codes = data
          .map((country, index) => ({
            id: index,
            name: `+${country.idd?.root?.replace("+", "") || ""}${
              country.idd?.suffixes ? country.idd.suffixes[0] : ""
            }`,
            country: country.name.common,
            flag: country.flags.svg,
          }))
          .filter((item) => item.name !== "+");

        setPhoneCodes(codes);

        const defaultCode = codes.find(
          (code) => code.name === countryCodeDefualt
        );
        setSelectedItem(
          defaultCode || { flag: null, name: "#00", country: "" }
        );
      } catch (error) {
        console.error("Error fetching phone codes:", error);
      }
    };

    fetchPhoneCodes();
  }, [countryCodeDefualt]);

  const filteredCodes = phoneCodes.filter((item) =>
    item.country.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Menu as="div" className="relative inline-block w-full">
      <div>
        <h4 className="text-lg text-gray-800">{title}</h4>
        <Menu.Button
          ref={buttonRef}
          className={`flex md:text-base text-sm items-center justify-between rounded-md bg-white border border-gray-300 md:p-3 px-3 py-3 w-full font-medium text-gray-700`}
        >
          {selectedItem && selectedItem.name && (
            <span className="flex items-center justify-between w-full text-xs md:justify-around md:text-base">
              {selectedItem.flag && (
                <img
                  src={selectedItem.flag}
                  alt={selectedItem.country || "flag"}
                  className="block w-5 h-4 shadow-lg md:w-7 md:h-5"
                />
              )}
              <p className="text-gray-500 m">{selectedItem.name}</p>
            </span>
          )}
        </Menu.Button>
      </div>
    </Menu>
  );
};

export default PhoneCodeDropdown;
